import React from 'react';

const Confluence = (props) => (
  <svg
    fill="currentColor"
    stroke="currentColor"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M9 3h9l8 8v18a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />
  </svg>
);

export default Confluence;
